import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import HBSiderAreaBox from './hbSiderAreaBox';
import HBSiderBox from './hbSiderBox';
import HomeSearch from './homeSearch';
import IpadAd from '../../../components/ipadAd';
import { getNewsDataList } from '../../../../services/indexApi';

class HBNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        listLeft: PropTypes.string,
    };

    state = {
        areaData: '',
        isShow: true,
    };

    async componentDidMount() {
        const { listLeft } = this.props;

        if (listLeft) {
            try {
                const areaData = await getNewsDataList(listLeft);

                this.setState({
                    areaData,
                    isShow: false,
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const { areaData, isShow } = this.state;
        const {
            content: { hbNewsSiderContent, hbNewsSiderAd, ipadAd3 },
            listLeft,
        } = this.props;

        return (
            <div id="homeSiderList" className={styles.sider_box}>
                <div className={styles.sider}>
                    {typeof areaData === 'string' && areaData !== '' ? (
                        <Chip
                            id={listLeft}
                            type="static"
                            title="地方站房产左侧栏"
                            groupName="家居文化要闻区左侧栏"
                            content={areaData}
                            position="relative">
                            <HBSiderAreaBox />
                        </Chip>
                    ) : (
                        ''
                    )}
                    {isShow ? (
                        <Chip
                            id="50094"
                            type="struct"
                            title="房产左侧栏"
                            groupName="家居文化要闻区左侧栏"
                            content={hbNewsSiderContent}
                            position="relative">
                            <HBSiderBox />
                        </Chip>
                    ) : (
                        ''
                    )}
                </div>
                <HomeSearch />
                <NoSSR>
                    {hbNewsSiderAd ? (
                        <Ad content={hbNewsSiderAd} />
                    ) : (
                        <Chip id="40105" type="static" title="广告4" groupName="家居文化要闻区左侧栏" content={ipadAd3}>
                            <IpadAd />
                        </Chip>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(HBNewsSider);
